const CODE_NAME_KEYS = new Set(["code", "name"]);

const hasPrimitiveDisplayValue = (value) =>
  value !== null && value !== undefined && String(value).trim() !== "";

export const isCodeNameObject = (value) => {
  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    return false;
  }

  const keys = Object.keys(value);
  if (keys.length === 0 || keys.length > 2) {
    return false;
  }

  if (!keys.every((key) => CODE_NAME_KEYS.has(key))) {
    return false;
  }

  return keys.some((key) => hasPrimitiveDisplayValue(value[key]));
};

export const hasDisplayValue = (value) => {
  if (value === null || value === undefined) {
    return false;
  }

  if (isCodeNameObject(value)) {
    return (
      hasPrimitiveDisplayValue(value.code) ||
      hasPrimitiveDisplayValue(value.name)
    );
  }

  if (Array.isArray(value)) {
    return value.some(hasDisplayValue);
  }

  if (typeof value === "object") {
    return Object.values(value).some(hasDisplayValue);
  }

  return String(value).trim() !== "";
};
